/* eslint-disable */
import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-location-required',
  templateUrl: './location-required.page.html',
  styleUrls: ['./location-required.page.scss']
})
export class LocationRequiredPage {
  showReasonPage = true;

  constructor(
    private modalCtrl: ModalController,
  ) {}

  onProgressButtonClick() {
    if (this.showReasonPage) {
      this.showReasonPage = false;
      return;
    } else {
      this.modalCtrl.dismiss();
    }
  }

  onBackClick() {
    this.showReasonPage = true;
  }
}
